import { fetchWrapper } from "../Helpers";

export const socketAuthService = {
  authenticateSocket
};

function authenticateSocket(socketId, channelName) {
  return fetchWrapper.post(
    `${process.env.REACT_APP_API_URL}/broadcasting/auth`,
    {
      socket_id: socketId,
      channel_name: channelName
    }
  );
}